import React, { useEffect } from "react";
import { Button, MenuItem, Select, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import SendInviteLinkModal from "./Modals/SendInviteLinkModal";
import Bus from "../../event/bus";
import { FormControl } from "@mui/base";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: 300,
    md: 600,
  },
  bgcolor: "background.paper",
  boxShadow: 0,
  p: 4,
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    // Remove the default blue outline
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent",
    },
  },
  menuPaper: {
    // Add space between the menu and the select
    marginTop: theme.spacing(-2),
  },
}));
function BottomStatusUpdate() {
  const classes = useStyles();
  const [status, setStatus] = React.useState("interview");

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openInviteSuccess, openSetInviteSuccess] = React.useState(false);
  const handleInviteSuccessOpen = () => openSetInviteSuccess(true);
  const handleInviteSuccessClose = () => openSetInviteSuccess(false);

  useEffect(() => {
    const handleCustomEvent = () => {
      handleInviteSuccessClose();
    };

    Bus.on("close-send-invite-modal", handleCustomEvent);

    return () => {
      Bus.off("close-send-invite-modal", handleCustomEvent);
    };
  }, []);
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      // border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),

      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
    },
  }));

  return (
    <div className="py-8 px-[24px]  bg-white">
      <div className="flex justify-between flex-col md:flex-row gap-8">
        <Button
          variant="contained"
          size="large"
          style={{
            backgroundColor: "#EDF5FF",
            color: "#98A2B3",
            boxShadow: "none",
            borderRadius: "8px",
          }}
          onClick={handleInviteSuccessOpen}
          className="font-[700]  text-[14px]"
        >
          Send invite link
        </Button>
        <div className="flex flex-col md:flex-row gap-8">
          <div className="flex justify-end gap-4">
            <div className="flex gap-4 items-center ">
              <p className="text-[#98A2B3] text-[10px] font-[500]">
                Set status:
              </p>
              <FormControl
                className={`${classes.formControl} customSelect`}
                variant="outlined"
              >
                <Select
                  MenuProps={{
                    classes: {
                      paper: classes.customMenuShadow,
                    },
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    transformOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                    PaperProps: {
                      className: classes.menuPaper,
                    },
                  }}
                  value={status}
                  onChange={handleChange}
                  sx={{
                    border: "1px solid black",

                    "&:focus": {
                      outline: "none",
                    },
                  }}
                  input={<BootstrapInput />}
                  className={`w-[190px] rounded-[5px] text-[12px] font-[500] bg-white !text-[#98A2B3]   `}
                >
                  <MenuItem value={"interview"}>Interview</MenuItem>
                  <MenuItem value={"hold"}>Hold</MenuItem>
                  <MenuItem value={"reject"}>Reject</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <Button
            variant="contained"
            size="large"
            style={{ boxShadow: "none" }}
            onClick={handleOpen}
          >
            Save Changes
          </Button>
        </div>
      </div>
      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="flex justify-between items-center">
              <p className="font-bold text-[24px]">Reason for status change</p>
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={handleClose}
                className="cursor-pointer"
              >
                <path
                  d="M27.5459 25.954C27.7572 26.1653 27.876 26.452 27.876 26.7509C27.876 27.0497 27.7572 27.3364 27.5459 27.5477C27.3346 27.7591 27.0479 27.8778 26.749 27.8778C26.4501 27.8778 26.1635 27.7591 25.9521 27.5477L20 21.5937L14.0459 27.5459C13.8346 27.7572 13.5479 27.8759 13.249 27.8759C12.9501 27.8759 12.6635 27.7572 12.4521 27.5459C12.2408 27.3345 12.1221 27.0479 12.1221 26.749C12.1221 26.4501 12.2408 26.1635 12.4521 25.9521L18.4062 19.9999L12.454 14.0459C12.2427 13.8345 12.1239 13.5479 12.1239 13.249C12.1239 12.9501 12.2427 12.6635 12.454 12.4521C12.6654 12.2408 12.952 12.122 13.2509 12.122C13.5498 12.122 13.8364 12.2408 14.0478 12.4521L20 18.4062L25.954 12.4512C26.1654 12.2398 26.452 12.1211 26.7509 12.1211C27.0498 12.1211 27.3364 12.2398 27.5478 12.4512C27.7591 12.6625 27.8778 12.9492 27.8778 13.248C27.8778 13.5469 27.7591 13.8336 27.5478 14.0449L21.5937 19.9999L27.5459 25.954Z"
                  fill="#292727"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="39"
                  height="39"
                  rx="7.5"
                  stroke="#98A2B3"
                />
              </svg>
            </div>
            <div className="mt-8">
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                placeholder="Add your comment"
                style={{ fontSize: "15px" }}
                className={`w-full ${classes.root}`}
              />
            </div>
            <div className="flex justify-end mt-4">
              <Button
                variant="contained"
                style={{ boxShadow: "none" }}
                size="large"
                onClick={handleOpen}
              >
                Save comment
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
      {openInviteSuccess && (
        <div>
          <SendInviteLinkModal
            openInviteSuccess={openInviteSuccess}
            dismiss={handleInviteSuccessClose}
          />
        </div>
      )}
    </div>
  );
}

export default BottomStatusUpdate;
